import {Modal, Box, Flex, Card, Text, Icon} from 'rimble-ui'
import arrowBack from '../assets/new-ui/arrow-left.png'

export default function ModalRequiredLogin(props) {
  const {toggleModal, setToggleModal} = props

  return (
    <>
      <Modal isOpen={toggleModal} className='modalOptionConnect'>
        <Card style={{ width: '100%', maxWidth: '420px', borderRadius: 10, backgroundColor: 'rgb(25, 27, 31)', border: '1px solid rgb(33, 36, 41)' }} p={0}>
          <Flex flexDirection='row' justifyContent='space-between' alignItems='center' color={'black'} p={16} borderBottom={'1px solid #D8D8D8'} mb={16}>
            <img src={arrowBack} alt='arrow back' style={{cursor:'pointer'}} onClick={() => setToggleModal(false)}/>
            <Text fontSize={'24px'} fontWeight={600} color={'white'} className='boxTitle'>Require log in!</Text>
            <Icon color='transparent' name='ArrowBack' />
          </Flex>
          <Box p={20} textAlign='center'>
            <Flex justifyContent='center' className='boxContent'>This function requires to log in before!</Flex>
          </Box>   
        </Card>
      </Modal>
    </>
  )
}